const verifyNumber = value => {
  var numberRex = new RegExp("^[0-9]+$");
  if (numberRex.test(value)) {
    return true;
  }
  return false;
};

const verifyActive = (isActive, name) => {
  return isActive === "" || isActive === name;
};

const verifyEmail = value => {
  var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (emailRex.test(value)) {
    return true;
  }
  return false;
};

const verifyPrefix = value => {
  var prefixRex = /^\++[0-9]{1,5}$/;
  return prefixRex.test(value);
};

const verifyLength = (value, length) => {
  if (value && value.length >= length) {
    return true;
  }
  return false;
};

export { verifyNumber, verifyEmail, verifyLength, verifyPrefix, verifyActive };
